import axios from 'axios';
import qs from "querystring";
import {PostMessageService, PostMessagesTypes} from "./postMessageService";
import {BaseService} from "./BaseService";
import {events} from "../../utils/pixiApp";

export class ApiServiceClass extends BaseService{

    async setTokenFromParent(token) {
        if (sessionStorage) sessionStorage.setItem('access_token', token);
    }

    removeToken() {
        if (sessionStorage) sessionStorage.removeItem('access_token');
    }

    async refreshToken() {
        PostMessageService.ListenPostMessage();
        await PostMessageService.postMessage({
            type: PostMessagesTypes.REFRESH_TOKEN,
        });
    }

    async getGameLobby() {
        const { data } = await this.get(`lobby/moments_fortune`);

        return data;
    }

    async setStartGame(bet) {
        const body = { bet: bet };
        const { data } = await this.post(`momentFortune/play`, body);

        return data;
    }

    async recover() {
        const { data } = await this.get(`momentFortune/recover`);

        return data;
    }

    async finish() {
        const { data } = await this.post(`momentFortune/finish`);

        return data;
    }

    async getUserBalance() {
        const { data } = await this.get(`profile`);

        return data;
    }

}